import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';


const RandomizedRender = ({ probabilities, children }) => {
  const [selectedComponent, setSelectedComponent] = useState(null);

  useEffect(() => {
    const randomNumber =  Math.random() * 100;

    let cumulativePercentage = 0;
    let selectedIndex = -1;

    for (let i = 0; i < probabilities.length; i++) {
      cumulativePercentage += probabilities[i];
      if (randomNumber <= cumulativePercentage) {
        selectedIndex = i;
        break;
      }
    }

    if (selectedIndex !== -1) {
      setSelectedComponent(children[selectedIndex]);
    }
  }, [probabilities, children]);

  return <>{selectedComponent}</>;
};

RandomizedRender.propTypes = {
  /**
   * Массив вероятностей, с короторыми будут отрендерены компоненты
   */
  probabilities: PropTypes.arrayOf(PropTypes.number),
};

export default RandomizedRender;
